import React from "react";
import { Typography as MuiTypography } from "@mui/material"
import { visuallyHidden } from "../libraries/material/utils"

const Typography = React.forwardRef((props, ref) => {
    if(props?.variant === "srOnly") {
        let sx = []
        if(Array.isArray(props?.sx)) {
            sx = sx.concat(props.sx, [visuallyHidden])
        } else if (props.sx) {
            sx = [visuallyHidden, props.sx]
        } else {
            sx = visuallyHidden
        }
        return <MuiTypography ref={ref} {...props} variant={undefined} sx={sx} />
    }
    return <MuiTypography ref={ref} {...props} />
})

export default Typography